import React, { useState, useEffect } from 'react';
import { api } from '../api';
import SearchBox from './SearchBox';
import { Spinner } from './UI';

const MARKET_SHORT = {
  MIL: 'Milano', NYSE: 'NYSE', NASDAQ: 'NASDAQ',
  XETRA: 'XETRA', PARIS: 'Parigi', LSE: 'Londra', RAW: 'Altro',
};

export default function AlertsPage({ onOpen }) {
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [sel, setSel]       = useState(null);   // titolo scelto per nuovo alert
  const [type, setType]     = useState('price_above');
  const [value, setValue]   = useState('');
  const [triggered, setTriggered] = useState([]);

  const load = () => {
    setLoading(true);
    api.alerts.get().then(r => setItems(r.items || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);
  useEffect(() => { api.alerts.check().then(r => setTriggered(r.triggered || [])).catch(() => {}); }, []);

  const addAlert = async () => {
    if (!sel || !value || isNaN(parseFloat(value))) return;
    const r = await api.alerts.add({ ticker: sel.ticker, market: sel.market, name: sel.name, type, value: parseFloat(value) });
    setItems(r.items || []);
    setSel(null); setValue('');
  };
  const removeAlert = async (id) => {
    const r = await api.alerts.remove(id);
    setItems(r.items || []);
  };

  const typeLabel = (t) => t === 'price_above' ? 'sale sopra' : 'scende sotto';

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#f1f5f9', marginBottom: 6 }}>Alert di prezzo</h1>
      <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>
        Imposta un avviso quando un titolo supera o scende sotto un prezzo. Gli alert vengono
        verificati quando apri l'app; se è scattato, ricevi una notifica del browser (se autorizzata).
      </p>

      {triggered.length > 0 && (
        <div style={{ background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: 12, padding: 16, marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#10b981', marginBottom: 8 }}>🔔 Alert scattati</div>
          {triggered.map((a, i) => (
            <div key={i} style={{ fontSize: 13, color: '#cbd5e1', padding: '3px 0' }}>
              <strong style={{ fontFamily: "'IBM Plex Mono', monospace" }}>{a.ticker}</strong> {typeLabel(a.type)} {a.value} — ora a {a.current_price}
            </div>
          ))}
        </div>
      )}

      <div style={{ background: '#131720', border: '1px solid #1e2736', borderRadius: 12, padding: 16, marginBottom: 20 }}>
        <div style={{ fontSize: 12, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 12 }}>Nuovo alert</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ width: 260 }}>
            {sel
              ? <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, background: '#0a0c10', border: '1px solid #1e2736', borderRadius: 8, padding: '7px 12px' }}>
                  <span style={{ fontFamily: "'IBM Plex Mono', monospace", color: '#e2e8f0' }}>{sel.ticker}</span>
                  <span style={{ color: '#475569', fontSize: 11 }}>{MARKET_SHORT[sel.market] || sel.market}</span>
                  <button onClick={() => setSel(null)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#475569', cursor: 'pointer' }}>×</button>
                </div>
              : <SearchBox onSelect={(o) => setSel(o)} />}
          </div>
          <select value={type} onChange={e => setType(e.target.value)} style={{ fontSize: 13, padding: '8px 10px', background: '#0a0c10', border: '1px solid #1e2736', borderRadius: 8, color: '#e2e8f0' }}>
            <option value="price_above">sale sopra</option>
            <option value="price_below">scende sotto</option>
          </select>
          <input value={value} onChange={e => setValue(e.target.value)} placeholder="prezzo" inputMode="decimal"
            style={{ width: 100, fontSize: 13, padding: '8px 12px', background: '#0a0c10', border: '1px solid #1e2736', borderRadius: 8, color: '#e2e8f0', outline: 'none' }} />
          <button onClick={addAlert} disabled={!sel || !value}
            style={{ fontSize: 13, padding: '8px 18px', borderRadius: 8, cursor: sel && value ? 'pointer' : 'default',
              background: sel && value ? '#1e3a5f' : 'transparent', color: sel && value ? '#60a5fa' : '#334155',
              border: '1px solid #2563eb40', fontWeight: 600 }}>Aggiungi</button>
        </div>
      </div>

      {loading ? <Spinner /> : items.length === 0 ? (
        <div style={{ padding: '30px 20px', textAlign: 'center', color: '#475569', fontSize: 14, background: '#0d1117', border: '1px solid #1e2736', borderRadius: 12 }}>
          Nessun alert impostato.
        </div>
      ) : (
        <div style={{ background: '#0d1117', border: '1px solid #1e2736', borderRadius: 12, overflow: 'hidden' }}>
          {items.map((a) => {
            const isHit = triggered.some(t => t.id === a.id);
            return (
              <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid #161c28' }}>
                <span style={{ fontSize: 14 }}>{isHit ? '🔔' : '○'}</span>
                <button onClick={() => onOpen(a)} style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', flex: 1 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', fontFamily: "'IBM Plex Mono', monospace" }}>{a.ticker}</span>
                  <span style={{ fontSize: 13, color: '#94a3b8', marginLeft: 10 }}>{typeLabel(a.type)} <strong>{a.value}</strong></span>
                  <span style={{ fontSize: 11, color: '#475569', marginLeft: 8 }}>{MARKET_SHORT[a.market] || a.market}</span>
                </button>
                <button onClick={() => removeAlert(a.id)} style={{ fontSize: 16, color: '#475569', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
